import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_FieldError } from '../../errors/fieldError/S_FieldError';
import { S_TextInput } from '../../inputs/textInput/S_TextInput';
import { S_FieldLabel } from '../../labels/fieldLabel/S_FIeldLabel';
import { FieldStatus } from '../FieldStatus';

interface S_TextFieldProps {
  id: string;
  value: string;
  labelText: string;
  fieldStatus: FieldStatus;
  isRequired?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
}

export const S_TextField = observer(
  (props: S_TextFieldProps): ReactElement => (
    <div>
      <S_FieldLabel
        isRequired={props.isRequired}
        text={props.labelText}
      />
      <S_TextInput
        id={props.id}
        value={props.value}
        error={!(props.fieldStatus.isValid ?? true)}
        placeholder={props.placeholder}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      {props.fieldStatus.isValid === false && <S_FieldError feedbacks={props.fieldStatus.errors} />}
    </div>
  )
);
